// SEND_TO_PARENT exit-card payload assembly, kept free of React/redux so it can be unit-tested
// without the full component graph (mirrors consentLogic.ts). The lead posted to the parent — the
// customer's own page / CRM, not the end consumer — always carries the full summary, total price,
// configuration image, and the on-demand summary-PDF link (full prices; the customer is entitled to
// its own data regardless of what the consumer-facing summary chooses to hide).

// The postMessage type marker the parent (customer page / CRM) listens for.
export const SEND_TO_PARENT_MESSAGE_TYPE = "SEND_TO_PARENT";

export interface SendToParentConsent {
    id: string;
    text: string;
}

// Fields are nullable because the upstream summary items carry optional names/article numbers; the
// values are passed through to the parent/CRM unchanged (existing behaviour).
export interface SendToParentSummaryItem {
    menuName: string | null | undefined;
    itemName: string | null | undefined;
    articleNumber: string | null | undefined;
}

export interface SendToParentPayloadInput {
    userInputs: Record<string, string>;
    consents: SendToParentConsent[];
    siteUrl: string;
    summary: SendToParentSummaryItem[];
    // Always emitted (the parent/CRM is entitled to the full price) — unlike the image/PDF below,
    // it is not omitted when absent.
    totalPrice?: string | null;
    // Nullable at the call site (no image yet / no config string); omitted from the payload when
    // absent so the parent receives a well-formed object with missing keys rather than null values.
    configurationImageUrl?: string;
    pdfUrl?: string;
}

export const buildSendToParentPayload = (input: SendToParentPayloadInput): Record<string, unknown> => {
    const payload: Record<string, unknown> = {
        type: SEND_TO_PARENT_MESSAGE_TYPE,
        userInputs: input.userInputs,
        consents: input.consents,
        siteUrl: input.siteUrl,
        summary: input.summary,
        totalPrice: input.totalPrice,
    };

    if (input.configurationImageUrl != null) {
        payload.configurationImageUrl = input.configurationImageUrl;
    }
    if (input.pdfUrl != null) {
        payload.pdfUrl = input.pdfUrl;
    }
    return payload;
};
